import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { BaseService } from '../../services/base.service';
import { NotificationsService } from '../../services/notification.service';

@Component({
  selector: 'ara-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.css']
})
export class OrderListComponent implements OnInit {
  @Input()
  OrderList: any = [];
  @Output()
  EditListItem: EventEmitter<any>;
  @Output()
  DeleteListItem: EventEmitter<any>;
  OrderInfo: OrderInfo;
  loggedInUserJSON: any;

  constructor(private commonService: CommonService, private baseService: BaseService, private notificationsService: NotificationsService) {
    this.EditListItem = new EventEmitter();
    this.DeleteListItem = new EventEmitter();
  }

  ngOnInit() {
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
  }
  editDetails(item) {
    this.EditListItem.emit(item);
  }

  deleteItem(deleted) {
    this.DeleteListItem.emit(deleted);
  }

  prepareSequenceInfo() {
    this.OrderInfo = new OrderInfo();
    this.OrderInfo.ModuleName = 'Category';
    this.OrderInfo.UserId = this.loggedInUserJSON.UserId;
    for (let index = 0; index < this.OrderList.length; index++) {
      const element = this.OrderList[index];
      let sequence = new SequenceInfo();
      sequence.ItemId = element.RuleId;
      sequence.SequenceId = index + 1;
      this.OrderInfo.SequenceInfo.push(sequence);
    }
    const apiRequest = {
      Model: this.OrderInfo
    }
    this.commonService.saveSequenceDetails(apiRequest, this.callbackMethodForSaveSequenceDetails.bind(this));
  }
  callbackMethodForSaveSequenceDetails(response) {
    if (response.Success) {
      this.notificationsService.toastNotify('success', 'Success Message', 'Sequence Information Saved successfully');
    }
  }

  // getOutput(output) {
  //   if (output) {
  //     this.ngOnInit();
  //   } 
  // }
}
class OrderInfo {
  ModuleName: string;
  SequenceInfo: SequenceInfo[] = [];
  UserId: number;
}
class SequenceInfo {
  ItemId: number;
  SequenceId: number;
}
